export const DEBITO_SICOB = [
  {
    "tipoNi": "CNPJ",
    "ni": "03763656000154",
    "numeroDebito": "00375034455",
    "codigoSituacaoFase": "0000010411",
    "situacaoFase": "AGUARD. COMUNIC. D.N. CONTRIB.",
    "inExigibilidade": false,
    "valorSaldoDevedor": 87792.81,
    "modalidade": "",
    "dataConsolidacao": "0000000000",
    "numeroDebitoCad": "00000000000",
    "quantidadeParcelasAtraso": "0000",
    "dataRequerimento": "0000000000"
  }
];
